export const state = {
  mode: 'single',
  listing: null,
  referenceImages: [],
  referenceSource: '',
  listingImages: [],
  lastFrame: null,
  promptSource: '',
  activeTaskId: null,
  previewStale: false,
  pollTimer: null,
  /** 新品项目 ID（项目绑定组件写入，保存时透传到后端用于预算门禁） */
  newProductProjectId: null,
};
